import { mcpConnectionTest } from "../mcpConnectionTest";
import { bearerAuth, oauthAuth, dcrOAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

export const firecrawl = defineProduct({
  name: "Firecrawl",
  tagLine: "Turn websites into AI-ready data",
  logo,
  tags: ["ai", "data"],
  variants: [
    productVariant({
      identifier: "firecrawl",
      authLabel: "API key",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.firecrawl\\.dev/.*",
      auth: (app) => bearerAuth(app.secret.apiKey),
      steps: [
        {
          title: "Get your API key",
          items: [
            {
              kind: "markdown",
              content:
                "Copy your API key from the [Firecrawl dashboard](https://www.firecrawl.dev/app/api-keys).",
            },
          ],
        },
        {
          title: "Paste your API key",
          items: [
            {
              kind: "input",
              label: "API key",
              placeholder: "fc-...",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://api.firecrawl.dev/v2/team/credit-usage",
      },
    }),

    productVariant({
      identifier: "firecrawlMcp",
      authLabel: "MCP OAuth",
      protocol: "http",
      defaultUrlPattern: () =>
        "https://mcp\\.firecrawl\\.dev/v2/mcp-oauth(?:\\?.*)?$",
      auth: () => oauthAuth,
      oauth: dcrOAuth({
        serverUrl: "https://mcp.firecrawl.dev/v2/mcp-oauth",
        issuer: "https://www.firecrawl.dev",
        authorizationEndpoint: "https://www.firecrawl.dev/api/oauth/authorize",
        tokenEndpoint: "https://www.firecrawl.dev/api/oauth/token",
        resource: "https://mcp.firecrawl.dev/v2/mcp-oauth",
        scopes: ["firecrawl:global", "offline_access"],
      }),
      steps: [
        {
          title: "Connect to Firecrawl",
          items: [
            {
              kind: "markdown",
              content:
                "Sign in to Firecrawl and select the team to authorize. This connection uses Firecrawl’s MCP server. For direct REST API requests, use the API key connection.",
            },
            { kind: "oauth" },
          ],
        },
      ],
      connectionTest: mcpConnectionTest(
        "https://mcp.firecrawl.dev/v2/mcp-oauth"
      ),
      usageHint: () =>
        "Call Firecrawl through streamable HTTP MCP at https://mcp.firecrawl.dev/v2/mcp-oauth. Load the mcp-client skill for the handshake and tool calls; authentication is injected automatically.",
    }),
  ],
});
